module.exports = __webpack_public_path__ + "assets/img/btn-detail-e9a6d805.png";